/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "dist/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_js__ = __webpack_require__(1);


const RECOMMEND_API_DOMAIN = 'https://recommend.browser.qq.com';
const DEBUG = __WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* default */].local.getItem('debug') === '1';
const isQB = /QQBrowser\//i.test(window.navigator.userAgent);
const isQB9 = /QQBrowser\/9\./i.test(window.navigator.userAgent);
const qbShowDocList = []; // 已展示的qb feeds id数组
const needReportArr = []; // 需要上报的数组，每隔2s上报一次并重置数组
const tmpNeedReportArr = []; // 剔除过路用户：需要上报的数组，第一次3s时上报，后续每2s上报一次，每次上报后重置数组
const newNeedReportArr = []; // 新上报口径，需要上报的数组，每隔3s上报一次并重置数组
const docBaseData = {}; // 文章基础数据

const QUERY = __WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* default */].querystring.parse(window.location.href);
const activeIndex = 0;
const OPTIONS = {
  selector: '.pc-qb-feeds-wrap',
  adtagPrefix: '',
  turnPage: 'scroll',
  float: undefined, // 默认为undefined, 0: 新页面打开, 1: 浮层打开
  size: 'normal', // normal为默认导航页尺寸，small为旧版newtab尺寸
  channels: [{ title: '推荐', cid: 98 }],
  togglePopup: status => {} // 浮层显示或关闭，status为true表示显示，false表示隐藏


  // 请求后台时不同入口的app key map
};const APP_KEY_MAP = {
  'err-': 2,
  'dh-': 3,
  'ie-': 4,
  'lx-': 5,
  'mi-': 6

  // 错误页的host
};let ERROR_PAGE_HOST = '';
try {
  ERROR_PAGE_HOST = new URL(window.pageUrl).hostname;
} catch (err) {
  // catch error
}

let GUID = '';
try {
  GUID = window.external.getGuid().replace(/-/g, '').toLocaleLowerCase();
} catch (err) {
  let userGuid = __WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* default */].local.getItem('userGuid');
  if (String(userGuid).length === 32) {
    GUID = userGuid;
  } else {
    GUID = __WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* default */].createGuid();
    __WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* default */].local.setItem('userGuid', GUID);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  RECOMMEND_API_DOMAIN,
  DEBUG,
  isQB,
  isQB9,
  GUID,
  QUERY,
  OPTIONS,
  APP_KEY_MAP,
  ERROR_PAGE_HOST,
  qbShowDocList,
  needReportArr,
  tmpNeedReportArr,
  newNeedReportArr,
  docBaseData,
  activeIndex
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(0);


// localStorage容错，错误页不支持localStorage
const local = {
  getItem: function (key) {
    try {
      return window.localStorage.getItem(key);
    } catch (err) {
      console.warn('not support localStorage');
      return null;
    }
  },
  setItem: function (key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (err) {
      console.warn('not support localStorage');
    }
  },
  removeItem: function (key) {
    try {
      window.localStorage.removeItem(key);
    } catch (err) {
      console.warn('not support localStorage');
    }
  }

  /**
   * querystring.parse/stringify
   */
};const querystring = {
  parse: function (url) {
    var obj = {};
    var str = url.indexOf('?') > -1 ? url.substring(url.indexOf('?') + 1) : url;
    var arr = str.split('&');
    for (var i = 0, len = arr.length; i < len; i++) {
      var tmp = arr[i].split('=');
      if (tmp[0].trim()) {
        obj[decodeURIComponent(tmp[0].trim())] = decodeURIComponent((tmp[1] || '').trim());
      }
    }
    return obj;
  },
  stringify: function (obj) {
    var arr = [];
    for (var i in obj) {
      arr.push(i + '=' + encodeURIComponent(obj[i]));
    }
    return arr.join('&');
  }

  /**
   * report
   */
};function report(json) {
  if (document.hidden || !Number.isInteger(json.key)) {
    return;
  }
  json.protocol = json.protocol || 8888;
  json.int1 = json.int1 || 0;
  json.int2 = json.int2 || 0;
  json.int3 = json.int3 || 0;
  json.str1 = json.str1 || '';
  json.str2 = json.str2 || '';
  json.str3 = json.str3 || '';

  try {
    window.external.dataReport(json.protocol, json.key, 0, json.int1, json.int2, json.int3, json.str1, json.str2, json.str3);
  } catch (err) {
    console.warn(err.message);
  }
  __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].DEBUG && console.log(json.protocol, json.key, 0, json.int1, json.int2, json.int3, json.str1, json.str2, json.str3);
}

/**
 * 判断元素是否完全在可视区(只根据垂直方向来判断)
 */
function isEleFullInViewport(ele) {
  if (ele) {
    var rect = ele.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  } else {
    return false;
  }
}

/**
 * 创建guid
 */
function createGuid() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

/**
 * 操作localStorage中的已读数组
 */
let visited = {
  visitedDocIdArr: JSON.parse(local.getItem('visitedDocId')) || [],
  add: function (docid) {
    if (this.has(docid)) return;
    this.visitedDocIdArr.length > 100 && this.visitedDocIdArr.pop();
    this.visitedDocIdArr.unshift(docid);
    local.setItem('visitedDocId', JSON.stringify(this.visitedDocIdArr)); // 更新已读列表
  },
  has: function (docid) {
    return this.visitedDocIdArr.indexOf(docid) !== -1;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  local,
  querystring,
  report,
  isEleFullInViewport,
  createGuid,
  visited
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_blazy_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_blazy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_blazy_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__report_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_feeds_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_feeds_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_feeds_css__);


/**
 * 获取feeds数据
 * @param  {Number} index global.OPTIONS.channels数组的索引
 * @param  {Number} size  请求条数
 * @return {Array}  feeds数据
 */
let getFeedsData = (() => {
  var _ref = _asyncToGenerator(function* (index, size = 10) {
    if (isLoading) {
      return;
    }
    isLoading = true;

    __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[index].page++;
    let cid = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[index].cid;
    let page = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[index].page;
    let title = '';

    // 阅读模式扩展阅读
    if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.turnPage === 'click' && page === 1) {
      size = 4;
      title = $parent.attr('data-title') || '';
    }

    // global.qbShowDocList字段传最新的200个文章id
    let url = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].RECOMMEND_API_DOMAIN + `/feeds/getRecommendList?app=${__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].APP_KEY_MAP[__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.adtagPrefix] || 0}&adtag=${__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.adtagPrefix + adtag}&size=${size}&guid=${__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].GUID}&channel=${cid}&page=${page}&qbShowDocList=${JSON.stringify(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].qbShowDocList.slice(-200))}&title=${title}&t=${Date.now()}`;

    // 错误页添加host参数
    if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.adtagPrefix === 'err-') {
      url += `&host=${__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].ERROR_PAGE_HOST}`;
    }

    return window.fetch(url, {
      credentials: 'include'
    }).then(function (res) {
      return res.json();
    }).then(function (res) {
      isLoading = false;
      if (res.records.length) {
        res.records.forEach(function (item) {
          item.extendDataObj = __WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].querystring.parse('?' + item.extendData);
        });
        return filterAlreadyShow(res.records);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[index].retry++;
        if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[index].retry >= 2) {
          // 最多请求两次
          return [];
        } else {
          __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[index].page--; // 重试时page重置
          return getFeedsData(index);
        }
      }
    }).catch(function (err) {
      isLoading = false;
      console.error('get feeds data error', err);
      return [];
    });
  });

  return function getFeedsData(_x) {
    return _ref.apply(this, arguments);
  };
})();

/**
 * 生成feeds内容
 */


/**
 * 加载tab数据
 * @param  {Number}  index       对应的tab类别
 * @param  {Number}  size        请求条数
 */
let loadTabData = (() => {
  var _ref2 = _asyncToGenerator(function* (index, size = 10) {
    const $content = $parent.find('.pc-qb-feeds-content').eq(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex);
    let $feedsTips = $('.feeds-tips');

    if ($feedsTips.length) {
      $feedsTips.html('<p class="feeds-loading"><i class="feeds-loading-icon"></i>内容加载中...</p>');
    } else {
      $content.append('<div class="feeds-tips"><p class="feeds-loading"><i class="feeds-loading-icon"></i>内容加载中...</p></div>');
      $feedsTips = $('.feeds-tips');
    }

    let data = yield getFeedsData(index, size);

    if (data.length) {
      $feedsTips.remove();
      $content.append(buildFeedsHtml(data));

      if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.turnPage === 'click') {
        $content.append('<div class="feeds-load-more">点击查看更多<i class="feeds-down-arrow"></i></div>');
      }

      // QBLog feedstime上报
      if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex].cid === 98 && __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex].page === 1) {
        $('.pc-qb-feeds').prepend('<img style="display: none" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" onload="window.__qblogfeedstime && window.__qblogfeedstime()">');
      }
    } else {
      $feedsTips.html('<p class="no-more-data">当前没有新内容了</p>');
    }

    // 收集曝光数据
    __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].exposureCollect();

    // lazyload feeds图片，延时再次执行解决某些情况未加载图片问题
    lazyload();
    setTimeout(lazyload, 200);
  });

  return function loadTabData(_x2) {
    return _ref2.apply(this, arguments);
  };
})();

/**
 * 关闭浮层
 */


let initFeeds = (() => {
  var _ref4 = _asyncToGenerator(function* () {
    if ($parent.length) {
      buildTabHtml();
      // await不能移除，会影响后面的上报
      yield loadTabData(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex, 10);
      bindEvent();
      __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].exposureCollect();
      setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].exposureReport(); // 每隔2s定时上报
        lazyload(); // 解决图片不加载问题
      }, 2000);

      // 剔除过路用户上报
      initCompleteTimeStamp = Date.now();
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].tmpExposureReport();
        setInterval(__WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].tmpExposureReport, 2000);
      }, 3000);

      // 停留时间初始值
      // startTime = Date.now()
    }
  });

  return function initFeeds() {
    return _ref4.apply(this, arguments);
  };
})();

let init = (() => {
  var _ref5 = _asyncToGenerator(function* (opt) {
    if (opt.selector === undefined || opt.adtagPrefix === undefined) {
      return console.error('selector and adtagPrefix are required');
    }

    Object.assign(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS, opt);
    __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels.forEach(function (item) {
      item.page = 0;
      item.idx = 0;
      item.retry = 0;
    });

    $parent = $(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.selector);
    initFeeds();
  });

  return function init(_x4) {
    return _ref5.apply(this, arguments);
  };
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * feeds模块
 */







let blazy;
let isLoading = false;
let adtag = 'newtab'; // 默认adtag，使用时会和global.OPTIONS.adtagPrefix配合使用
let initCompleteTimeStamp = 0; // feeds init完成时间戳，用户过路用户上报(init完3s内有滚动则立即上报，无滚动则第3s会进行上报)
// let startTime = 0  // 停留时间开始时间戳
// let endTime = 0    // 停留时间结束时间戳

let $parent;
let $html = $('html');
let $body = $('body');
let $window = $(window);

/**
 * 过滤已展示的feeds
 * @param {Array} arr
 */
function filterAlreadyShow(arr) {
  return arr.filter(item => {
    __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].docBaseData[item.docId] = item;

    // 广告不做去重
    if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].qbShowDocList.indexOf(item.docId) > -1 && ['qb', 'baidu'].indexOf(item._src) === -1) {
      return false;
    } else {
      __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].qbShowDocList.push(item.docId);
      return true;
    }
  });
}function buildFeedsHtml(arr) {
  // QB9不展示视频，视频流mp4请求失败率高
  if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].isQB9) {
    arr = arr.filter(item => item.feedsType !== 'video');
  }

  let html = '';
  arr.forEach(item => {
    // url中会使用到idx，有图无图idx都加1
    __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex].idx++;
    item.idx = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex].idx;

    if (item.docId) {
      html += Object(__WEBPACK_IMPORTED_MODULE_3__template_js__["a" /* default */])(item);
    }
  });
  return html;
}

/**
 * image lazyload
 */
function lazyload() {
  if (blazy) {
    setTimeout(() => {
      blazy.revalidate();
    }, 50);
  } else {
    blazy = new __WEBPACK_IMPORTED_MODULE_0__lib_blazy_js___default.a({
      container: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.selector
    });
  }
}function closePopup() {
  $('.pc-qb-feeds-popup').remove();
  $html.removeClass('no-scroll');
  __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.togglePopup && __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.togglePopup(false);
}

/**
 * 展示正负反馈弹层
 */
function showFeedbackPopup(ele) {
  let feedbackPopup = ele.find('.feedback-popup');
  if (feedbackPopup.length) {
    feedbackPopup.show();
  } else {
    ele.append(`
      <div class="feedback-popup">
        <div class="feedback-list">
          <span class="feedback-option" data-reason="5">文章质量差</span>
          <span class="feedback-option" data-reason="2">内容低俗</span>
          <span class="feedback-option" data-reason="1">广告</span>
          <span class="feedback-option" data-reason="3">标题党</span>
        </div>
        <div class="feedback-tips">选择理由，精准屏蔽 <span class="feedback-submit" data-reason="">不感兴趣</span></div>
      </div>
    `);
  }
}

/**
 * 隐藏正负反馈弹层
 */
function hideFeedbackPopup() {
  $parent.find('.feedback-popup').hide();
  $parent.find('.hate').removeAttr('style'); // 移除所有.hate行内的样式
}

/**
 * 删除feeds
 * @param {String} id
 */
function deleteFeeds(id) {
  $parent.find(`[data-docid="${id}"]`).remove();
  let index = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].qbShowDocList.indexOf(id);
  if (index > -1) {
    __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].qbShowDocList.splice(index, 1);
  }

  $window.trigger('scroll'); // 触发scroll来决定是否要loadTabData
  lazyload(); // 触发lazyload
}

function bindEvent() {
  // 页面展示收集上报(从预加载变成可见时收集上报)
  $(document).on('visibilitychange', function () {
    __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].exposureCollect();
    if (document.hidden) {
      __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].reportStayTime();
    }
  });

  // 滚动加载
  if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.turnPage === 'scroll') {
    $window.on('scroll', function () {
      if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex].url) {
        return;
      }

      window.requestAnimationFrame(function () {
        let scrollHeight = document.documentElement.scrollHeight; // 整个页面高度
        let clientHeight = document.documentElement.clientHeight; // 可视区高度
        let scrollY = window.scrollY; // 已滚动高度
        if (scrollHeight - clientHeight - scrollY <= 500 && !isLoading) {
          loadTabData(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex);
          __WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].report({ key: 104 });
        }
        __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].exposureCollect();

        // 3s内有滚动则立即上报
        if (Date.now() - initCompleteTimeStamp < 3000) {
          __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].tmpExposureReport();
        }
      });
    });
  }

  // 点击加载
  if (__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.turnPage === 'click') {
    $parent.on('click', '.feeds-load-more', function () {
      $(this).remove();
      loadTabData(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex);
      __WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].report({
        key: 101,
        str3: 'newtab.click.ui.feedsLoadMore'
      });
    });
  }

  // Esc关闭
  $window.on('keydown', function (e) {
    if (e.keyCode === 27) {
      closePopup();
    }
  });

  // parent点击行为
  $window.on('click', function () {
    hideFeedbackPopup();
  });

  // 切换feeds频道
  $parent.on('click', '.pc-qb-feeds-head span', function () {
    let $this = $(this);
    if ($this.hasClass('active')) {
      return;
    }

    __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex = $this.index();
    $parent.find('.pc-qb-feeds-head .active').removeClass('active');
    $parent.find('.pc-qb-feeds-content').hide().eq(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex).show();
    $this.addClass('active');

    const channel = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex];

    if (channel.url) {
      $parent.find('.pc-qb-feeds-content').eq(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex).html(`
        <iframe src="${channel.url}" width="728" height="${channel.height}" frameborder="0" scrolling="no"></iframe>
      `);
    } else {
      loadTabData(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex);
    }

    __WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].report({
      key: 101,
      int1: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels[__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex].cid,
      str3: 'newtab.click.ui.feedsChannel'
    });
  });

  // lazyload自定义事件，解决新标签页更新自定义设置时
  $parent.on('lazyload', function () {
    lazyload();
  });

  // hate按钮
  $parent.on('click', '.hate', function (e) {
    e.preventDefault();
    e.stopPropagation();
    let $this = $(this);
    hideFeedbackPopup();
    showFeedbackPopup($this.parents('.desc'));
    // feedback popup显示时，关闭按钮mouseleave时不消失
    $this.css('display', 'block');
  });

  // feedback popup
  $parent.on('click', '.feedback-popup', function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  // 提交正负反馈
  $parent.on('click', '.feedback-submit, .feedback-option', function () {
    let $this = $(this);
    let $feedsItem = $this.parents('.feeds-item');
    let reason = $this.attr('data-reason') || '';
    let docid = $feedsItem.attr('data-docid');
    let feedsData = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].docBaseData[docid];

    deleteFeeds(docid);

    $.ajax({
      url: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].RECOMMEND_API_DOMAIN + '/feeds/feedback',
      method: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: {
        'guid': __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].GUID,
        'id': feedsData.docId,
        'src': feedsData._src,
        'adtag': __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.adtagPrefix + adtag,
        'feedsType': feedsData.feedsType,
        'extData': feedsData.extendData,
        'idx': $feedsItem.index() + 1,
        'feedback': 0,
        'reason': reason,
        'time': Date.now()
      }
    });
  });

  // feeds点击上报
  $parent.on('click', '.feeds-item', function (e) {
    let $this = $(this);
    let float = Number($this.attr('data-float'));
    let url = $this.attr('href');
    let feedsType = $this.attr('data-type');
    let docId = $this.attr('data-docid');

    // 弹层打开
    if (float > 0) {
      e.preventDefault();
      $html.addClass('no-scroll');
      $this.addClass('doc-id-visited'); // 添加已读样式
      __WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].visited.add(docId); // 已读ID记录在localStorage中
      $body.append(`
        <div class="pc-qb-feeds-popup">
          ${feedsType === 'video' ? '' : `<div class="pc-qb-feeds-base" data-adtag-prefix="${__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.adtagPrefix}"></div>`}
          <iframe class="pc-qb-feeds-iframe" src="${url}" frameborder="0" allowfullscreen="true"></iframe>
        </div>
      `);
      // iframe加载完时，展示白底，这样点击相关推荐时不会闪
      $('.pc-qb-feeds-iframe').on('load', function () {
        setTimeout(() => {
          $('.pc-qb-feeds-base').show();
        }, 300);
      });

      // 展示浮层
      __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.togglePopup && __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.togglePopup(true);
    }

    __WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].report({
      key: 101,
      int1: $this.index() + 1,
      str1: $this.attr('href'),
      str2: window.newTabAdtag,
      str3: 'newtab.click.href.feeds'
    });

    // feeds插入广告上报
    if ($this.attr('data-src') === 'qb') {
      __WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].report({
        key: 101,
        int1: $this.index() + 1,
        str1: $this.attr('href'),
        str2: window.newTabAdtag,
        str3: 'newtab.click.href.feedsConfigAd'
      });

      const data = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].docBaseData[docId];

      $.ajax({
        url: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].RECOMMEND_API_DOMAIN + '/feeds/report',
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        data: {
          'guid': __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].GUID,
          'list': [{
            _src: data._src,
            adtag: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.adtagPrefix + adtag,
            feedsType: data.feedsType || '',
            docId: data.docId,
            extData: data.extendData,
            logType: 'access',
            time: parseInt(Date.now() / 1000, 10),
            idx: $this.index() + 1
          }]
        }
      });
    }
  });

  // feeds放开右键
  $parent.on('contextmenu', function (e) {
    e.stopPropagation();
  });

  // 关闭页面时上报
  $window.on('beforeunload', function () {
    __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].exposureReport();
    __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].tmpExposureReport();
    __WEBPACK_IMPORTED_MODULE_4__report_js__["a" /* default */].reportStayTime();
  });

  // 接受iframe消息
  window.addEventListener('message', (() => {
    var _ref3 = _asyncToGenerator(function* (res) {
      if (res.origin.endsWith('.qq.com') || res.origin === 'null') {
        __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].DEBUG && console.log('newtab receive message', res.data);
        switch (res.data.cmd) {
          case 'closePopup':
            closePopup();
            break;
          case 'scrollToId':
            if (res.data.id) {
              let $item = $parent.find('.pc-qb-feeds-content').eq(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex).find(`[data-docid="${res.data.id}"]`);
              let $prevAll = $item.prevAll(':visible'); // :visible修复全面屏皮肤时$tmp为baidu广告，导致滚动到了页面顶部
              if ($item.length && $prevAll.length > 2) {
                let $tmp = $prevAll.eq(1);

                // $html QB10生效，$body QB9生效
                $tmp.length && $html.add($body).animate({ 'scrollTop': $tmp.offset().top }, 0);
              }
            }
            break;
          case 'getNext':
            if (res.data.id) {
              let $item = $parent.find('.pc-qb-feeds-content').eq(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex).find(`[data-docid="${res.data.id}"]`);
              let argument = [];
              if ($item.length) {
                let $next = $item.nextAll('[data-float="1"][data-type="article"]').eq(0);
                // 自动加载下一屏列表的数据
                if ($next.length === 0) {
                  // await不能移除，加载完之后再取$next
                  yield loadTabData(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex);
                  __WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].report({ key: 104 });
                  $next = $item.nextAll('[data-float="1"][data-type="article"]').eq(0);
                }

                // 确保$next存在，否则argument返回空数组
                if ($next.length) {
                  argument = [__WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].querystring.parse($next.attr('href'))];
                }
              }
              res.source.postMessage(Object.assign(res.data, { argument: argument }), res.origin);
              __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].DEBUG && console.log('newtab post message', Object.assign(res.data, { argument: argument }));
            }
            break;
          case 'getNextAll':
            if (res.data.id) {
              let index = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].qbShowDocList.indexOf(res.data.id);
              let idArr = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].qbShowDocList.slice(index + 1);
              if (idArr.length === 0) {
                // await不能移除，加载完之后再取idArr
                yield loadTabData(__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].activeIndex);
                __WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].report({ key: 104 });
                idArr = __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].qbShowDocList.slice(index + 1);
              }
              let argument = idArr.map(function (id) {
                return __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].docBaseData[id];
              }).filter(function (item) {
                return item.extendDataObj.float > 0 && item.feedsType === 'article' && item.images.length > 0;
              });

              res.source.postMessage(Object.assign(res.data, { argument: argument }), res.origin);
              __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].DEBUG && console.log('newtab post message', Object.assign(res.data, { argument: argument }));
            }
            break;
          case 'deleteFeeds':
            if (res.data.id) {
              deleteFeeds(res.data.id);
            }
            break;
        }
      }
    });

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  })(), false);
}

/**
 * 创建初始tab html
 */
function buildTabHtml() {
  let headHtml = '';
  let bodyHtml = '';
  __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels.forEach((item, index) => {
    headHtml += `<span class="${index === 0 ? 'active' : ''}" data-log="FEEDS:TAB.${index + 1}">${item.title}</span>`;
    bodyHtml += `<div class="pc-qb-feeds-content" style="display: ${index === 0 ? 'block' : 'none'};"></div>`;
  });
  $parent.html(`
    <div class="pc-qb-feeds" data-adtag-prefix="${__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.adtagPrefix}" data-size="${__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.size}">
      <div class="pc-qb-feeds-head" style="display: ${__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].OPTIONS.channels.length > 1 ? 'flex' : 'none'}">${headHtml}</div>
      <div class="pc-qb-feeds-body">${bodyHtml}</div>
    </div>
  `);
}

window.qbfeeds = window.qbfeeds || {};
window.qbfeeds.init = init;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  hey, [be]Lazy.js - v1.8.2 - 2016.10.25
  A fast, small and dependency free lazy load script (https://github.com/dinbror/blazy)
  (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy
*/
;
(function (root, blazy) {
    if (true) {
        // AMD. Register bLazy as an anonymous module
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (blazy),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = blazy();
    } else {
        // Browser globals. Register bLazy on window
        root.Blazy = blazy();
    }
})(this, function () {
    'use strict';

    //private vars

    var _source,
        _viewport,
        _isRetina,
        _supportClosest,
        _attrSrc = 'src',
        _attrSrcset = 'srcset';

    // constructor
    return function Blazy(options) {
        //IE7- fallback for missing querySelectorAll support
        if (!document.querySelectorAll) {
            var s = document.createStyleSheet();
            document.querySelectorAll = function (r, c, i, j, a) {
                a = document.all, c = [], r = r.replace(/\[for\b/gi, '[htmlFor').split(',');
                for (i = r.length; i--;) {
                    s.addRule(r[i], 'k:v');
                    for (j = a.length; j--;) a[j].currentStyle.k && c.push(a[j]);
                    s.removeRule(0);
                }
                return c;
            };
        }

        //options and helper vars
        var scope = this;
        var util = scope._util = {};
        util.elements = [];
        util.destroyed = true;
        scope.options = options || {};
        scope.options.error = scope.options.error || false;
        scope.options.offset = scope.options.offset || 100;
        scope.options.root = scope.options.root || document;
        scope.options.success = scope.options.success || false;
        scope.options.selector = scope.options.selector || '.b-lazy';
        scope.options.separator = scope.options.separator || '|';
        scope.options.containerClass = scope.options.container;
        scope.options.container = scope.options.containerClass ? document.querySelectorAll(scope.options.containerClass) : false;
        scope.options.errorClass = scope.options.errorClass || 'b-error';
        scope.options.breakpoints = scope.options.breakpoints || false;
        scope.options.loadInvisible = scope.options.loadInvisible || false;
        scope.options.successClass = scope.options.successClass || 'b-loaded';
        scope.options.validateDelay = scope.options.validateDelay || 25;
        scope.options.saveViewportOffsetDelay = scope.options.saveViewportOffsetDelay || 50;
        scope.options.srcset = scope.options.srcset || 'data-srcset';
        scope.options.src = _source = scope.options.src || 'data-src';
        _supportClosest = Element.prototype.closest;
        _isRetina = window.devicePixelRatio > 1;
        _viewport = {};
        _viewport.top = 0 - scope.options.offset;
        _viewport.left = 0 - scope.options.offset;

        /* public functions
         ************************************/
        scope.revalidate = function () {
            initialize(scope);
        };
        scope.load = function (elements, force) {
            var opt = this.options;
            if (elements && elements.length === undefined) {
                loadElement(elements, force, opt);
            } else {
                each(elements, function (element) {
                    loadElement(element, force, opt);
                });
            }
        };
        scope.destroy = function () {
            var util = scope._util;
            if (scope.options.container) {
                each(scope.options.container, function (object) {
                    unbindEvent(object, 'scroll', util.validateT);
                });
            }
            unbindEvent(window, 'scroll', util.validateT);
            unbindEvent(window, 'resize', util.validateT);
            unbindEvent(window, 'resize', util.saveViewportOffsetT);
            util.count = 0;
            util.elements.length = 0;
            util.destroyed = true;
        };

        //throttle, ensures that we don't call the functions too often
        util.validateT = throttle(function () {
            validate(scope);
        }, scope.options.validateDelay, scope);
        util.saveViewportOffsetT = throttle(function () {
            saveViewportOffset(scope.options.offset);
        }, scope.options.saveViewportOffsetDelay, scope);
        saveViewportOffset(scope.options.offset);

        //handle multi-served image src (obsolete)
        each(scope.options.breakpoints, function (object) {
            if (object.width >= window.screen.width) {
                _source = object.src;
                return false;
            }
        });

        // start lazy load
        setTimeout(function () {
            initialize(scope);
        }); // "dom ready" fix
    };

    /* Private helper functions
     ************************************/
    function initialize(self) {
        var util = self._util;
        // First we create an array of elements to lazy load
        util.elements = toArray(self.options);
        util.count = util.elements.length;
        // Then we bind resize and scroll events if not already binded
        if (util.destroyed) {
            util.destroyed = false;
            if (self.options.container) {
                each(self.options.container, function (object) {
                    bindEvent(object, 'scroll', util.validateT);
                });
            }
            bindEvent(window, 'resize', util.saveViewportOffsetT);
            bindEvent(window, 'resize', util.validateT);
            bindEvent(window, 'scroll', util.validateT);
        }
        // And finally, we start to lazy load.
        validate(self);
    }

    function validate(self) {
        var util = self._util;
        for (var i = 0; i < util.count; i++) {
            var element = util.elements[i];
            if (elementInView(element, self.options) || hasClass(element, self.options.successClass)) {
                self.load(element);
                util.elements.splice(i, 1);
                util.count--;
                i--;
            }
        }
        if (util.count === 0) {
            self.destroy();
        }
    }

    function elementInView(ele, options) {
        var rect = ele.getBoundingClientRect();

        if (options.container && _supportClosest) {
            // Is element inside a container?
            var elementContainer = ele.closest(options.containerClass);
            if (elementContainer) {
                var containerRect = elementContainer.getBoundingClientRect();
                // Is container in view?
                if (inView(containerRect, _viewport)) {
                    var top = containerRect.top - options.offset;
                    var right = containerRect.right + options.offset;
                    var bottom = containerRect.bottom + options.offset;
                    var left = containerRect.left - options.offset;
                    var containerRectWithOffset = {
                        top: top > _viewport.top ? top : _viewport.top,
                        right: right < _viewport.right ? right : _viewport.right,
                        bottom: bottom < _viewport.bottom ? bottom : _viewport.bottom,
                        left: left > _viewport.left ? left : _viewport.left
                    };
                    // Is element in view of container?
                    return inView(rect, containerRectWithOffset);
                } else {
                    return false;
                }
            }
        }
        return inView(rect, _viewport);
    }

    function inView(rect, viewport) {
        // Intersection
        return rect.right >= viewport.left && rect.bottom >= viewport.top && rect.left <= viewport.right && rect.top <= viewport.bottom;
    }

    function loadElement(ele, force, options) {
        // if element is visible, not loaded or forced
        if (!hasClass(ele, options.successClass) && (force || options.loadInvisible || ele.offsetWidth > 0 && ele.offsetHeight > 0)) {
            var dataSrc = getAttr(ele, _source) || getAttr(ele, options.src); // fallback to default 'data-src'
            if (dataSrc) {
                var dataSrcSplitted = dataSrc.split(options.separator);
                var src = dataSrcSplitted[_isRetina && dataSrcSplitted.length > 1 ? 1 : 0];
                var srcset = getAttr(ele, options.srcset);
                var isImage = equal(ele, 'img');
                var parent = ele.parentNode;
                var isPicture = parent && equal(parent, 'picture');
                // Image or background image
                if (isImage || ele.src === undefined) {
                    var img = new Image();
                    // using EventListener instead of onerror and onload
                    // due to bug introduced in chrome v50 
                    // (https://productforums.google.com/forum/#!topic/chrome/p51Lk7vnP2o)
                    var onErrorHandler = function () {
                        if (options.error) options.error(ele, "invalid");
                        addClass(ele, options.errorClass);
                        unbindEvent(img, 'error', onErrorHandler);
                        unbindEvent(img, 'load', onLoadHandler);
                    };
                    var onLoadHandler = function () {
                        // Is element an image
                        if (isImage) {
                            if (!isPicture) {
                                handleSources(ele, src, srcset);
                            }
                            // or background-image
                        } else {
                            ele.style.backgroundImage = 'url("' + src + '")';
                        }
                        itemLoaded(ele, options);
                        unbindEvent(img, 'load', onLoadHandler);
                        unbindEvent(img, 'error', onErrorHandler);
                    };

                    // Picture element
                    if (isPicture) {
                        img = ele; // Image tag inside picture element wont get preloaded
                        each(parent.getElementsByTagName('source'), function (source) {
                            handleSource(source, _attrSrcset, options.srcset);
                        });
                    }
                    bindEvent(img, 'error', onErrorHandler);
                    bindEvent(img, 'load', onLoadHandler);
                    handleSources(img, src, srcset); // Preload
                } else {
                    // An item with src like iframe, unity games, simpel video etc
                    ele.src = src;
                    itemLoaded(ele, options);
                }
            } else {
                // video with child source
                if (equal(ele, 'video')) {
                    each(ele.getElementsByTagName('source'), function (source) {
                        handleSource(source, _attrSrc, options.src);
                    });
                    ele.load();
                    itemLoaded(ele, options);
                } else {
                    if (options.error) options.error(ele, "missing");
                    addClass(ele, options.errorClass);
                }
            }
        }
    }

    function itemLoaded(ele, options) {
        addClass(ele, options.successClass);
        if (options.success) options.success(ele);
        // cleanup markup, remove data source attributes
        removeAttr(ele, options.src);
        removeAttr(ele, options.srcset);
        each(options.breakpoints, function (object) {
            removeAttr(ele, object.src);
        });
    }

    function handleSource(ele, attr, dataAttr) {
        var dataSrc = getAttr(ele, dataAttr);
        if (dataSrc) {
            setAttr(ele, attr, dataSrc);
            removeAttr(ele, dataAttr);
        }
    }

    function handleSources(ele, src, srcset) {
        if (srcset) {
            setAttr(ele, _attrSrcset, srcset); //srcset
        }
        ele.src = src; //src 
    }

    function setAttr(ele, attr, value) {
        ele.setAttribute(attr, value);
    }

    function getAttr(ele, attr) {
        return ele.getAttribute(attr);
    }

    function removeAttr(ele, attr) {
        ele.removeAttribute(attr);
    }

    function equal(ele, str) {
        return ele.nodeName.toLowerCase() === str;
    }

    function hasClass(ele, className) {
        return (' ' + ele.className + ' ').indexOf(' ' + className + ' ') !== -1;
    }

    function addClass(ele, className) {
        if (!hasClass(ele, className)) {
            ele.className += ' ' + className;
        }
    }

    function toArray(options) {
        var array = [];
        var nodelist = options.root.querySelectorAll(options.selector);
        for (var i = nodelist.length; i--; array.unshift(nodelist[i])) {}
        return array;
    }

    function saveViewportOffset(offset) {
        _viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + offset;
        _viewport.right = (window.innerWidth || document.documentElement.clientWidth) + offset;
    }

    function bindEvent(ele, type, fn) {
        if (ele.attachEvent) {
            ele.attachEvent && ele.attachEvent('on' + type, fn);
        } else {
            ele.addEventListener(type, fn, { capture: false, passive: true });
        }
    }

    function unbindEvent(ele, type, fn) {
        if (ele.detachEvent) {
            ele.detachEvent && ele.detachEvent('on' + type, fn);
        } else {
            ele.removeEventListener(type, fn, { capture: false, passive: true });
        }
    }

    function each(object, fn) {
        if (object && fn) {
            var l = object.length;
            for (var i = 0; i < l && fn(object[i], i) !== false; i++) {}
        }
    }

    function throttle(fn, minDelay, scope) {
        var lastCall = 0;
        return function () {
            var now = +new Date();
            if (now - lastCall < minDelay) {
                return;
            }
            lastCall = now;
            fn.apply(scope, arguments);
        };
    }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_template_css__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_template_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__css_template_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_global__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_api__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_ad__ = __webpack_require__(6);
/**
 * feeds template
 */





/**
 * 生成多图的html
 * @param  {Array} imgArr 图片数组
 * @return {String} 拼接后的html
 */
function buildMultiPicHtml(imgArr) {
  let html = '';
  imgArr.slice(0, 3).forEach(item => {
    html += `<div class="pic b-lazy" data-src="${item}"></div>`;
  });
  return html;
}

/**
 * feeds 模版编译
 * @param {Object} data feeds单条数据
 * @param {String} type feeds模板类型
 */
function compile(item, type) {
  let html = '';
  let beenVisited = __WEBPACK_IMPORTED_MODULE_2__js_api__["a" /* default */].visited.has(item.docId) ? 'doc-id-visited' : '';
  let activeIndex = __WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].activeIndex;

  switch (type) {
    case 'yunying':
    case 'union':
      html = `
        <div class="feeds-list-ad feeds-item" data-src="${item._src}" data-docid="${item.docId}" data-type="${item.feedsType || ''}" data-float="0" data-log="FEEDS:TAB${activeIndex + 1}.${item.idx}" data-qbad="feeds_list" data-qbad-data="${encodeURIComponent(JSON.stringify(item.sdk))}" data-reported="1"></div>
      `;
      break;
    case 'sticky':
      // 置顶
      html = `
        <a class="sticky feeds-item ${beenVisited}" target="_blank" href="${item.__href}" data-src="${item._src}" data-docid="${item.docId}" data-type="${item.feedsType || ''}" data-float="${item.extendDataObj.float}" data-log="FEEDS:TAB${activeIndex + 1}.${item.idx}">
          <div class="text">
            <div class="desc clearfix">
              <i class="feeds-top"></i>
              <h3 class="title">${item.title}</h3>
              <span class="from">${item.from}</span>
            </div>
          </div>
        </a>
      `;
      break;
    case 'none':
      // 无图
      html = `
        <a class="no-pic feeds-item ${beenVisited}" target="_blank" href="${item.__href}" data-src="${item._src}" data-docid="${item.docId}" data-type="${item.feedsType || ''}" data-float="${item.extendDataObj.float}" data-log="FEEDS:TAB${activeIndex + 1}.${item.idx}">
          <div class="text">
            <h3 class="title">${item.title}</h3>
            <div class="desc clearfix">
              <span>${item.from ? item.from + '&nbsp;&nbsp;' : ''}${item.commentNum ? item.commentNum + '评' : ''}</span>
              <span class="hate"></span>
            </div>
          </div>
        </a>
      `;
      break;
    case 'single':
      // 单图
      html = `
        <a class="single-pic feeds-item ${beenVisited}" target="_blank" href="${item.__href}" data-src="${item._src}" data-docid="${item.docId}" data-type="${item.feedsType || ''}" data-float="${item.extendDataObj.float}" data-log="FEEDS:TAB${activeIndex + 1}.${item.idx}">
          <div class="pic b-lazy" data-src="${item.images[0]}"></div>
          <div class="text">
            <h3 class="title">${item.title}</h3>
            <div class="desc clearfix">
              ${item.__txw_hot ? '<i class="feeds-hot"></i>' : ''}
              ${item.feedsType === 'video' ? '<i class="feeds-video"></i>' : ''}
              <span>${item.from ? item.from + '&nbsp;&nbsp;' : ''}${item.commentNum ? item.commentNum + '评' : ''}</span>
              <span class="hate"></span>
            </div>
          </div>
        </a>
      `;
      break;
    case 'three':
      // 三图
      html = `
        <a class="multi-pic feeds-item ${beenVisited}" target="_blank" href="${item.__href}" data-src="${item._src}" data-docid="${item.docId}" data-type="${item.feedsType || ''}" data-float="${item.extendDataObj.float}" data-log="FEEDS:TAB${activeIndex + 1}.${item.idx}">
          <h3 class="title">${item.title}</h3>
          <div class="pic-wrap">
            ${buildMultiPicHtml(item.images)}
          </div>
          <div class="desc clearfix">
            ${item.__txw_hot ? '<i class="feeds-hot"></i>' : ''}
            <span>${item.from ? item.from + '&nbsp;&nbsp;' : ''}${item.commentNum ? item.commentNum + '评' : ''}</span>
            <span class="hate"></span>
          </div>
        </a>
      `;
      break;
  }
  return html;
}

/**
 * 生成单条feeds html
 * @param {Object} item
 */
function buildFeeds(item) {
  let protocol = window.location.protocol === 'http:' ? 'http:' : 'https:'; // 错误页取到的是chrome-error:

  // 2为popuplist，已下线
  let urlPrefixMap = {
    0: `${protocol}//zixun.browser.qq.com/detail/index.html?adtag=detail&adtagPrefix=${__WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].OPTIONS.adtagPrefix}`,
    1: `${protocol}//zixun.browser.qq.com/newtabpopup/detail.html?adtag=newtabpopup&adtagPrefix=${__WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].OPTIONS.adtagPrefix}`,
    video: `${protocol}//zixun.browser.qq.com/videopopup/detail.html?adtag=videopopup&adtagPrefix=${__WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].OPTIONS.adtagPrefix}`
  };
  item.extendDataObj.float = item.extendDataObj.float || 0;

  // 如果OPTIONS里配置了float，则优先使用OPTIONS里的配置
  if (__WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].OPTIONS.float !== undefined) {
    item.extendDataObj.float = __WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].OPTIONS.float;
  }

  let urlPrefix = urlPrefixMap[item.feedsType] || urlPrefixMap[item.extendDataObj.float]; // 优先匹配video
  if (item._src === 'qb') {
    item.__href = item.url;
  } else {
    item.__href = urlPrefix + `&id=${item.docId}&_src=${item._src}&url=${encodeURIComponent(item.url || '')}&feedsType=${item.feedsType}&extendData=${encodeURIComponent(item.extendData)}&idx=${item.idx}`;
  }

  // 错误页添加host参数
  if (__WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].OPTIONS.adtagPrefix === 'err-') {
    let host = '';
    try {
      host = new URL(window.pageUrl).hostname;
    } catch (err) {
      // catch error
    }
    item.__href += `&host=${host}`;
  }

  // fr统计字段传递
  if (__WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].QUERY.fr !== undefined) {
    item.__href += `&fr=${__WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].QUERY.fr}`;
  }

  // hot标识
  item.__txw_hot = 0;
  if (/txw_hot=1/.test(item.extendData)) {
    item.__txw_hot = 1;
  }

  // top标识
  item.__sticky = 0;
  if (/sticky=1/.test(item.extendData)) {
    item.__sticky = 1;
  }

  // 错误页不显示hot文章
  if (__WEBPACK_IMPORTED_MODULE_1__js_global__["a" /* default */].OPTIONS.adtagPrefix === 'err-' && item.__txw_hot === 1) {
    return '';
  }

  // 过滤空图片
  item.images = item.images.filter(function (src) {
    return !!src;
  });
  let picLen = item.images.length;

  // 通过广告sdk插入运营内容
  if (item._src === 'baidu' || item._src === '360') {
    return compile(__WEBPACK_IMPORTED_MODULE_3__js_ad__["a" /* default */].buildUnionData(item), 'union');
  } else if (item._src === 'qb') {
    return compile(__WEBPACK_IMPORTED_MODULE_3__js_ad__["a" /* default */].buildSdkData(item), 'yunying');
  } else if (picLen >= 3) {
    // 多图
    return compile(item, 'three');
  } else if (picLen >= 1) {
    // 单图
    return compile(item, 'single');
  } else if (picLen === 0) {
    // 无图
    if (item.__sticky === 1) {
      return compile(item, 'sticky');
    } else {
      return compile(item, 'none');
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (buildFeeds);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(0);


/**
 * 生成广告sdk需要的数据
 * @param {Object} item feeds数据
 */
function buildSdkData(item) {
  let templateName;
  const picLen = item.images.length;
  if (picLen >= 3) {
    templateName = 'feeds-list-three';
  } else {
    templateName = item.isBigPic ? 'feeds-list-big' : 'feeds-list-one';
  }
  item.sdk = {
    'src': 'yunying',
    'channel': __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].OPTIONS.adtagPrefix,
    'special': item.special,
    'data': {
      'position': 'static',
      'width': '100%',
      'template': {
        'name': templateName,
        'data': {
          'id': item.docId,
          'img': item.images,
          'url': item.url,
          'title': item.title,
          'from': item.from,
          'tags': item.tags,
          'extendData': item.extendData
        }
      }
    }
  };
  return item;
}

/**
 * 生成联盟广告需要的数据
 * @param {Object} item feeds数据
 */
function buildUnionData(item) {
  item.sdk = {
    'src': item._src,
    'data': item.data
  };
  return item;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  buildSdkData,
  buildUnionData
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(1);



let isFeedsShowReport = false; // feeds展示上报标志
let timer = null; // feeds曝光上报timer

/**
 * feeds列表曝光收集
 */
function exposureCollect() {
  // feeds模块曝光上报
  let $firstVisibleLink = $(__WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].OPTIONS.selector).find('.feeds-item').eq(0);
  if (!document.hidden && !isFeedsShowReport && $firstVisibleLink.is(':visible') && __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].isEleFullInViewport($firstVisibleLink[0])) {
    isFeedsShowReport = true;
    __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].report({ key: 103 });
  }

  // feeds列表曝光收集
  if (!document.hidden) {
    window.clearTimeout(timer);
    timer = setTimeout(() => {
      let arr = document.elementsFromPoint(window.innerWidth / 2, window.innerHeight - 10);
      let target = null;
      for (let i = 0, len = arr.length; i < len; i++) {
        if (arr[i].classList.contains('feeds-item')) {
          target = arr[i];
          break;
        }
      }
      let $target = $(target);
      let prevAll = $target.prevAll('.feeds-item:not([data-reported="1"])').get().reverse();

      // 判断target是否完全展示
      if (__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].isEleFullInViewport($target.find('.pic')[0]) && $target.attr('data-reported') !== '1') {
        prevAll.push(target);
      }
      let tmpArr = prevAll.map(item => {
        let docId = $(item).attr('data-docid');
        let data = __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].docBaseData[docId];
        return {
          _src: data._src,
          adtag: __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].OPTIONS.adtagPrefix + 'newtab',
          feedsType: data.feedsType || '',
          docId: data.docId,
          extData: data.extendData,
          idx: $(item).index() + 1,
          logType: 'exposure',
          time: parseInt(Date.now() / 1000, 10)
        };
      });
      __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].needReportArr = __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].needReportArr.concat(tmpArr);
      __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].tmpNeedReportArr = __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].tmpNeedReportArr.concat(tmpArr);
      $(prevAll).attr('data-reported', 1);
    }, 200);
  }
}

/**
 * 发送曝光上报
 */
function exposureReport() {
  if (__WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].needReportArr.length) {
    $.ajax({
      url: __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].RECOMMEND_API_DOMAIN + '/feeds/report',
      method: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: {
        'guid': __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].GUID,
        'list': __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].needReportArr
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].needReportArr = [];
  }
}

/**
 * 发送临时曝光上报：剔除过路用户
 */
function tmpExposureReport() {
  if (__WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].tmpNeedReportArr.length) {
    $.ajax({
      url: __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].RECOMMEND_API_DOMAIN + '/feeds/report',
      method: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: {
        'guid': __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].GUID,
        'list': __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].tmpNeedReportArr.map(item => {
          return Object.assign({}, item, {
            adtag: __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].OPTIONS.adtagPrefix + 'newtablist'
          });
        })
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].tmpNeedReportArr = [];
  }
}

/**
 * 上报停留时间
 */
function reportStayTime() {
  // 只上报一次，有endTime字段说明已经上报，停留时间大于1s才有效
  // if (window.navigator.sendBeacon && !endTime && startTime && Date.now() - startTime >= 1000) {
  //     endTime = Date.now();
  //     let obj = {
  //         'guid': global.GUID,
  //         'adtag': global.OPTIONS.adtagPrefix + adtag,
  //         'time': endTime - startTime
  //     };
  //     let blob = new Blob([$.param(obj)], {type: 'application/x-www-form-urlencoded'});
  //     window.navigator.sendBeacon('https://recommend.browser.qq.com/feeds/report', blob);
  // }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  exposureCollect,
  exposureReport,
  tmpExposureReport,
  reportStayTime
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
//# sourceMappingURL=feeds.js.map